import { useQuery } from "@tanstack/react-query";
import { fetchAllSeriesCarting } from "../api/fetchAllSeriesCarting";

export const useAllSeriesCarting = (body, enabled = true) => {
  const { data, error, isLoading, isFetching, refetch } = useQuery({
    queryKey: ["allSeriesCarting", body],
    queryFn: () => fetchAllSeriesCarting(body),
    enabled: !!body && enabled,
  });

  return {
    data: data?.result || [],
    error,
    isLoading: isLoading || isFetching,
    refetch,
  };
};

